<template>
  <v-container fluid>
    <PageTitle>
      <v-icon left>
        fas fa-fw fa-comments
      </v-icon>
      Text Message Templates
      <template v-slot:buttons>
        <v-btn :to="{name: 'admin.sinch_template.create'}"
               color="primary">
          New Template
        </v-btn>
      </template>
    </PageTitle>

    <v-card v-for="template in filteredTemplates"
            :key="template.id"
            class="mb-4">
      <v-card-title class="justify-space-between">
        <div>
          {{ template.name }}
        </div>
        <StatusChip :status="template.status"
                    label
                    small>
        </StatusChip>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-textarea :value="template.content"
                    outlined
                    dense
                    disabled
                    rows="2"
                    auto-grow
                    hide-details>
        </v-textarea>
      </v-card-text>
      <v-card-actions class="px-4">
        <v-btn v-if="template.is_welcome_template === false"
               :to="{name: 'admin.sinch_template.edit', params: {templateID: template.id}}">
          Edit
        </v-btn>
        <div v-else
             class="text-caption">
          Due to telecom regulations, you cannot edit the welcome template.
        </div>
      </v-card-actions>
    </v-card>

  </v-container>
</template>
<script>
import PageTitle from '../../components/PageTitle.vue';
import StatusChip from '../../components/StatusChip.vue';
import {orderBy} from 'lodash';
import {mapGetters} from 'vuex';

export default {
  components: {PageTitle, StatusChip},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('sinch', [
      'templates',
    ]),
    filteredTemplates() {
      return orderBy(this.templates, ['is_welcome_template', 'slug'], ['asc', 'asc']);
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch('sinch/fetchTemplates');
    },
  }
}
</script>
